<template lang="pug">
  div.editable-wrapper
    input.editable-text(
      ref="inputbox",
      type="text",
      autocomplete="off",
      autocorrect="off",
      autocapitalize="off",
      spellcheck="false",
      placeholder="-",
      v-model="text",
      :class="{'no-value': !value}",
      :disabled="state!==1",
      @keydown="validate")
    transition-group.edit-buttons(
      name="editable",
      mode="out-in",
      tag="div")
      button.plain-button.editable-button(v-if="state===0", @click="edit", key="edit")
        icon(name="edit", scale="1.3")
      button.plain-button.editable-button(v-if="state===2", key="wait")
        icon(name="spinner", scale="1.3", spin)
      button.plain-button.editable-button(v-if="state===1", @click="cancel", key="cancel")
        icon(name="times-circle", scale="1.3")
      button.plain-button.editable-button(v-if="state===1", @click="submit", key="submit")
        icon(name="check", scale="1.3")
</template>

<script>
export default {
  name: 'editable',
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number]
    },
    wait: {
      type: Boolean,
      default: false
    },
    available: {
      type: RegExp
    }
  },
  watch: {
    value: function (newValue) {
      if (newValue !== undefined)
          this.text = newValue
    },
    wait (n) {
      if (n) {
        this.store = this.state
        this.state = 2
      } else {
        this.state = this.store
      }
    }
  },
  methods: {
    edit () {
      this.state = 1
      this.$nextTick(() => {
        this.$refs.inputbox.focus()
        // this.$refs.inputbox.select()
      })
      if (this.name === 'approver_name') {
        let valueSplit = this.text.split('(')
        this.text = valueSplit[0]
      }
    },
    validate (evt) {
      if (!this.available) return
      const {key, which, keyCode} = evt
      const code = which || keyCode
      if (key.length === 1 && !this.available.test(key)) {
        evt.preventDefault()
        this.$log.info(`[NOT ALLOWED KEY: ${key}(${code})]`)
      }
    },
    cancel () {
      this.state = 0
      this.text = this.value
    },
    submit () {
      this.state = 0
      this.$emit('changed', this.name, this.text)
      // if (this.name === 'approver_name') {
      //   this.text = this.value
      // }
    }
  },
  mounted () {
    this.text = this.value
  },
  data () {
    return {
      store: 0,
      state: 0,
      text: ''
    }
  }
}
</script>

<style lang="scss">
.editable-wrapper {
  display: inline-block;
  width: 100%;
  .editable-text {
    border: 0;
    width: 100%;
    background-color: transparent;
    outline: none;
    color: #6092d2;
    font-size: inherit;
    display: inline-block;
    &:disabled {
      //color: #2c3e50;
      color: #000000;
    }
    &::placeholder {
      color: #cacaca;
      font-style: italic;
    }
  }
  .edit-buttons {
    position: absolute;
    top: -1px; right: 5px;

    svg {
      color: #888;
    }
  }
}

.editable-button {
  transition: transform 500ms, opacity 500ms;
}
.editable-enter {
  transform: translateX(20px);
  opacity: 0;
}
.editable-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}
.editable-leave-active {
  position: absolute;
}
</style>
